import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import { CheckIcon } from 'images'

export default function CustomCheckBox({ checked, onChange, className, label }) {
  return (
    <label className={classnames('custom-checkbox', className, { 'custom-checkbox--checked': checked })}>
      <input
        type="checkbox"
        className="custom-checkbox__input"
        checked={checked}
        onChange={onChange}
      />
      
      <span className="custom-checkbox__box">
        {checked && <CheckIcon width={11} height={8} />}
      </span>

      {label ? <span className="custom-checkbox__label">{label}</span> : null}
    </label>
  )
}

CustomCheckBox.propTypes = {
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string,
  label: PropTypes.string,
}
